import logo from '@assets/logo.png';
import { useLocalization } from '@lib/localization';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Content = () => {
  const { t } = useLocalization();

  const items = [
    {
      icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
      title: t('SignIn_Content1_Title'),
      description: t('SignIn_Content1_Description'),
    },
    {
      icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
      title: t('SignIn_Content2_Title'),
      description: t('SignIn_Content2_Description'),
    },
    {
      icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
      title: t('SignIn_Content3_Title'),
      description: t('SignIn_Content3_Description'),
    },
    {
      icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
      title: t('SignIn_Content4_Title'),
      description: t('SignIn_Content4_Description'),
    },
  ];

  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        <img src={logo} width={150} />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom >
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{
              color: 'text.secondary', fontWeight: '200'
            }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
};

export default Content;
